
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { SMNps, SMUser, SMValidationModal } from "@/store";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    SidebarProvider,
    SidebarInset,
    // AppSidebarPortal: () => import("@/components/AppSidebar/AppSidebarPortal/AppSidebarPortal.vue"),
    AppSidebarNew: () => import("@/components/V2/AppSidebar/AppSidebar.vue"),
    AppMain: () => import("@/components/AppMain/AppMain.vue"),
    Questionnaire: () => import("@/modules/Questionnaire/Questionnaire.vue"),
    HorizontalQuestionnaire: () =>
      import("@/components/HorizontalQuestionnaire/HorizontalQuestionnaire.vue"),
    OnboardingModal: () => import("@/components/OnboardingModal/OnboardingModal.vue"),
    GlobalErrorPopUp: () => import("@/components/Popups/GlobalErrorPopUp.vue"),
    NpsScore: () => import("@/components/NpsScore/NpsScore.vue"),
    ChatBot: () => import("@/components/ChatBot/ChatBot.vue"),
    ChatBotIcon: () => import("@/components/ChatBot/ChatBotIcon.vue"),
    SubmitRequestVisaPopUp: () => import("@/components/Popups/SubmitRequestVisaPopUp.vue"),
    NewWidgetGetSponsorLicenceDialog: () =>
      import("@/components/V2/WidgetGetSponsorLicence/NewWidgetGetSponsorLicenceDialog.vue"),
  },
})
export default class Layout extends Vue {
  get isUserSet() {
    return !!SMUser?.user;
  }

  @Watch("isUserSet", { immediate: true })
  setUserChanged(val: boolean) {
    if (!val) return;

    this.checkValidation();
  }

  get showOnboarding() {
    if (SMUser.isValidationPassed || SMUser.isCandidate || SMUser.isExpert) return false;

    return true;
  }

  checkValidation(): void {
    if (SMUser.isValidationPassed || SMUser.isCandidate || SMUser.isExpert) return;

    SMValidationModal.open();
  }

  get isNpsOpen() {
    return SMNps.isNpsOpen;
  }

  closeNps() {
    SMNps.closeNps();
  }

  get showChatBotIcon() {
    return SMUser.isExpert;
  }

  isChatBotOpen = false;

  openChatBot() {
    this.isChatBotOpen = true;
  }

  closeChatBot() {
    this.isChatBotOpen = false;
  }

  showSLDialog = false;

  get isPrepaidSL() {
    return SMUser.prepaidSL;
  }

  get caseId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  get isCompliance(): boolean {
    return !this.caseId;
  }
}
